var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    {
      attrs: { title: _vm.title, button_add: true },
      on: { click_add: _vm.row_create },
    },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "12", sm: "12" } },
            [
              _c("v-data-table", {
                staticStyle: { "white-space": "nowrap" },
                attrs: {
                  headers: _vm.headers,
                  items: _vm.rules,
                  "hide-default-header": _vm.empty,
                  height: _vm.rules.length > 7 ? 32 * 7 + 32 + 16 : undefined,
                  "disable-pagination": "",
                  dense: "",
                  "hide-default-footer": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.launchTime",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(item.launchTime)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.row_update(item)
                              },
                            },
                          },
                          [_vm._v("mdi-pencil")]
                        ),
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.row_moveup(item)
                              },
                            },
                          },
                          [_vm._v("mdi-arrow-up-thick")]
                        ),
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.row_movedown(item)
                              },
                            },
                          },
                          [_vm._v("mdi-arrow-down-thick")]
                        ),
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.row_remove(item)
                              },
                            },
                          },
                          [_vm._v("mdi-delete")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "12", sm: "12" } },
            [_c("v-divider")],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-4", attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "6" } },
            [
              _c("v-checkbox", {
                attrs: { label: "Start on launch", "hide-details": "" },
                model: {
                  value: _vm.model.startOnLaunch,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "startOnLaunch", $$v)
                  },
                  expression: "model.startOnLaunch",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "3", md: "3" } },
            [
              _c("v-text-field", {
                attrs: { label: "Profile Age", "hide-details": "" },
                model: {
                  value: _vm.value.profileAge,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "profileAge", _vm._n($$v))
                  },
                  expression: "value.profileAge",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-guard-time-rule-dialog", { ref: "dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }